"use client";

export default function Select({
  children,
  className = "",
  rightPad = "pr-10",
  ...props
}) {
  return (
    <div className="relative group">
      <select
        {...props}
        className={[
          "w-full appearance-none rounded-xl px-3 py-2.5",
          rightPad,
          "text-sm md:text-base",
          "bg-white hover:bg-slate-100",
          "border border-gray-200",
          "text-gray-700",
          "shadow-sm",
          "transition-all outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40",
          "disabled:opacity-60 disabled:cursor-not-allowed",
          className,
        ].join(" ")}
      >
        {children}
      </select>

      <svg
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 h-5 w-5 text-gray-500 group-focus-within:text-teal-600"
        viewBox="0 0 20 20"
        fill="currentColor"
        aria-hidden
      >
        <path
          fillRule="evenodd"
          d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.21 8.29a.75.75 0 0 1 .02-1.08z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  );
}
